import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Button, Form } from '@anytag/shared-atoms';
import { SelectedRangeOption, PostReportMode } from '@anytag/shared-types';
import { TextSearchField, RangeDatePickerField } from '@anytag/shared-molecules';
import { cn } from '@anytag/shared-utils';
import { PostReportFilterFormValues, PostReportFilterFormKeys } from './schema-types';

export interface TemplateProps {
  children?: ReactNode;
  onSubmit?: () => void;
}

export const Template = ({ onSubmit, children }: TemplateProps) => {
  const { t } = useTranslation();
  const { setValue, watch } = useFormContext<PostReportFilterFormValues>();
  const [modeValue, startDateValue, endDateValue] = watch(['mode', 'startDate', 'endDate']);

  const isAllTime = !startDateValue && !endDateValue;
  const isGridMode = modeValue === PostReportMode.GRID;

  const handleModeChange = (mode: PostReportMode) => {
    setValue('mode', mode);
    onSubmit?.();
  };

  return (
    <Form.Fields>
      <Form.Field className="mr-auto flex flex-none">
        <Button
          variant="outline"
          title={t('Summary')}
          className={styles.button(isGridMode)}
          prefixIcon={{ icon: 'grid', size: '16px' }}
          onClick={() => handleModeChange(PostReportMode.GRID)}
        />
        <Button
          variant="outline"
          title={t('Details')}
          className={styles.button(!isGridMode)}
          prefixIcon={{ icon: 'list', size: '16px' }}
          onClick={() => handleModeChange(PostReportMode.TABLE)}
        />
      </Form.Field>

      {!isGridMode ? (
        <>
          <TextSearchField<PostReportFilterFormKeys>
            name="keyword"
            onSubmit={onSubmit}
            placeholder={t<string>('Search.PostReportFilter')}
          />
          <RangeDatePickerField<PostReportFilterFormKeys>
            onSubmit={onSubmit}
            css={{ flex: 'none' }}
            clearTitle={t('All time')}
            name={{ startDate: 'startDate', endDate: 'endDate' }}
            customInputTextNode={isAllTime ? <p>{t('All time')}</p> : undefined}
            rangeList={[
              SelectedRangeOption.TODAY,
              SelectedRangeOption.LAST_SEVEN_DAYS,
              SelectedRangeOption.TODAY_TO_MONTH_AGO,
              SelectedRangeOption.THIS_MONTH,
              SelectedRangeOption.LAST_MONTH,
              SelectedRangeOption.CLEAR,
              SelectedRangeOption.CUSTOM
            ]}
          />
        </>
      ) : null}

      {children}
    </Form.Fields>
  );
};
const styles = {
  button: (isActive?: boolean) =>
    cn(
      'min-w-[93px] text-tertiary',
      { 'bg-primary/10 z-1 border-black-90 text-primary': isActive },
      'first-of-type:rounded-l-sm last-of-type:-ml-px last-of-type:rounded-r-sm'
      // '&:first-of-type': { borderRadius: '3px 0 0 3px' },
      // '&:last-of-type': { marginLeft: '-1px', borderRadius: '0 3px 3px 0' }
    )
  // css({
  //   minWidth: '93px',
  //   ...(isActive
  //     ? { zIndex: 1, color: '#3892E5', borderColor: '#3892E5', background: 'rgba(56, 146, 229, 0.1)' }
  //     : { color: THEME.text.colors.gray.lv3 }),
  //   '&:first-of-type': { borderRadius: '3px 0 0 3px' },
  //   '&:last-of-type': { marginLeft: '-1px', borderRadius: '0 3px 3px 0' }
  // })
};
